import Image from 'next/image'

import { SOMETHING_WENT_WRONG } from '@/app/constants'

const UserAutoError = () => (
  <div className="flex h-full flex-col items-center justify-center gap-20 pb-[120px]">
    <Image
      src="/images/shared/Blocked.png"
      alt=""
      width={180}
      height={180}
      className="rotate-12"
    />

    <p className="text-center font-pro text-grey-60 text-20">
      {SOMETHING_WENT_WRONG}...
    </p>
  </div>
)

export default UserAutoError
